export default {
      id: "data-export-blue-usage",
      viewBox: "0 0 25 25",
      url: "images/" + "sprite.svg#data-export-blue-usage",
      toString: function () {
        return this.url;
      }
    }